module.exports = __webpack_public_path__ + "0d38036338a3960dfabf438cbe57abac.MP3";